import { rs } from "./rs";
import { en } from "./en";
import { RouteStrings } from "../RouteStrings";

const routes: Record<string, RouteStrings> = {en, rs};

export default routes;
